import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=641b3af7"
import script from "./BasePopup.vue?vue&type=script&lang=js"
export * from "./BasePopup.vue?vue&type=script&lang=js"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=641b3af7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports